import axios, { Method } from 'axios';
import { compile } from 'path-to-regexp';
import { isLocalhost } from 'utils/utils';

let query = {};

// 获取环境信息
let env = process.env.NODE_ENV || 'development';

const baseUrl = {
  // todo 域名
  development: isLocalhost ? '/req' : 'https://www.hungrystudio.com/api',
  production: 'https://www.hungrystudio.com/api',
};

const headers = {
  'content-type': 'application/json',
};

function pathRgxToUrl(path: string, data: object) {
  if (!data) return path;
  const toPath = compile(path);
  return toPath(data);
}

// 支持的接口类型
// method: get poast put delete patch

const request =
  (methed: Method | undefined) =>
  (url: string) =>
  (data = {}, header = {}): any => {
    let params = { ...query, _v: Date.now() };
    if (methed === 'get') {
      params = { ...data, ...params };
    }
    let requestObj = {
      baseURL: baseUrl[env],
      url: pathRgxToUrl(url, data),
      headers: {
        ...headers,
        ...header,
      },
      params,
      method: methed,
      timeout: 10000,
      data,
    };

    // 如果浏览器不支持 DELETE PUT ，需要跟后端约定，将 method 换成 post， 或者 再将真正的方法以参数的形式传过去处理
    // axios 默认是 status >= 200 && status < 300;
    return new Promise((resolve, reject) => {
      axios(requestObj)
        .then((res) => {
          if (res.status === 200 && res.data.code === 200) {
            resolve(res.data.data);
          } else {
            if (res.data.code === 403) {
              // todo 拉起授权登录
            } else {
              // 后端有对这个进行错误提醒， 如果 有 error_type 则是后端处理过的状态码
              reject(res);
            }
          }
        })
        .catch((error) => {
          console.error('服务器出错了，请刷新重试');
          // 后端有对这个进行错误提醒， 如果 有 error_type 则是后端处理过的状态码
          if (error.response) {
            reject(error.response);
          } else {
            reject(error);
          }
          console.error('api request error:', error);
        });
    });
  };

export const GET = request('get');
export const POST = request('post');
export const PUT = request('put');
export const DELETE = request('delete');
